"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  AUS: {
    phone: '+61 2 8317 5411',
    email: 'support@shootsta.com'
  },
  US: {
    phone: '+1 760 756 7479',
    email: 'support@shootsta.com'
  },
  UK: {
    phone: '020 8068 8551',
    email: 'support@shootsta.com'
  },
  SG: {
    phone: '+656957 7352',
    email: 'support@shootsta.com'
  },
  ASIA_US: {
    phone: '+852 2780 5586',
    email: 'support@shootsta.com'
  }
};
exports.default = _default;